import React from 'react';
import styled from 'styled-components';
import CalloutImg from '../../assets/hcp-opt-callout-key-cut.png';
import * as colors from '../../util/colors';
import { Text, Heading, NotationBlock, WYSIWYG } from '../../util/typography';
import ComponentWrapper from '../layout/ComponentWrapper';
import { createLocalScaleFunction, createMarkup, componentTheme } from '../../util/functions';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    margin: auto; 
    justify-items:stretch;
    align-items: stretch;
`;

const Container = styled.div`
    grid-column: 1 / 1;
    grid-row: 1 / 1;
    padding: ${createLocalScaleFunction(20, 320, 24, 952)} ${createLocalScaleFunction(20, 320, 30, 952)};
    background-color: ${colors.white};
    border: 1px solid ${colors.pebble};
    color: ${props => (props.theme === 'dark' ? 'black' : colors.white)};
    border-radius: 8px;
    margin: 0 10px 10px 0;
    /* margin: -10px 0 0 -10px;     */
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;
const InlineImage = styled.div`
    padding-top: 5px; //adjust to align with text on desktop

    margin-right: 20px;
    flex: 0 1 auto;

    & img {
        margin-bottom: 10px;
    }
`;

const StyledTitle = styled(Heading.H4)`
    &.marginBottom{
        margin-bottom: 10px;
    }
`;

const InlineContent = styled.div`
    flex: 1 1 230px;
    min-width: 230px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const GradientBG = styled.div`
    grid-column: 1 / 1;
    grid-row: 1 / 1;
    background-image: ${ (props) => props.isQsub ? "linear-gradient(106deg, #4A0075 0%, #5A008F 28.26%, #6A00A8 55.05%, #7C02BB 78.93%, #8215BA 101.34%)" : "radial-gradient(circle at 23% 0, #006ead, #36864a 87%)"};
    width: calc(100% - 10px);
    /* margin: 10px 0 0 10px;
    padding: 1px 10px 10px 1px; */
    background-color: ${colors.white};
    color: ${props => (props.theme === 'dark' ? 'black' : colors.white)};
    border-radius: 8px;
    box-sizing: border-box;
    margin: 10px 0 0 10px;
`;

const AdditionalInformationTitle = styled(Heading.H5)`
    margin-top: 30px;
`;

const AdditionalInformationDescription = styled(WYSIWYG)`
    display: inline-block;
    margin-top: 20px;
`;

const SecondaryCallout = props => {
    const theme = componentTheme(true, props.sectionTheme, props.theme);
    // const isImage = props.isImage ? props.isImage : true;
    const isImage = props.isImage ?? true;
    return (
        <ComponentWrapper>
            <Wrapper>
                <GradientBG isQsub={props.isQsub}/>
                <Container>
                    <ContentWrapper>
                        {
                            isImage ?
                        <InlineImage>
                            <img width={props.imgWidth?props.imgWidth:"100%"} alt={props.alt} src={props.imgSrc ? props.imgSrc : CalloutImg} aria-hidden="true"/>
                        </InlineImage> :
                            null
                        }
                        <InlineContent>
                            <StyledTitle className={props.text ? "marginBottom" : ""} dangerouslySetInnerHTML={createMarkup(props.title)} />

                            <Text.Body dangerouslySetInnerHTML={createMarkup(props.text)}/>
                        </InlineContent>
                    </ContentWrapper>
                </Container>
                {props.additionalInformation &&
                    <>
                        {props.additionalInformation.map((item, index) =>
                            <div key={index}>
                                {item.title && <AdditionalInformationTitle as='H4' theme={theme} dangerouslySetInnerHTML={{ __html: item.title }}></AdditionalInformationTitle>}
                                {item.text && <AdditionalInformationDescription theme={theme} dangerouslySetInnerHTML={{ __html: item.text }}></AdditionalInformationDescription>}
                            </div>
                        )}
                    </>
                }
                {(props.footnotes || props.definitions) && <NotationBlock footnotes={props.footnotes} definitions={props.definitions} />}
            </Wrapper>
        </ComponentWrapper>
    );
};

export default SecondaryCallout;
